import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ComunService } from '../domain/usecase/comun/comun-use-case';
import { InicioComponent } from './components/inicio/inicio.component';
import { MenuComponent } from './components/menu/menu.component';
import { ModalConfirmacionComponent } from './components/modal-confirmacion/modal-confirmacion.component';
import { AssetspipePipe } from './pipes/dataasync.pipe';
// PIPES
import { RouterModule } from '@angular/router';
import { ProgramacionService } from '../infraestructure/programacion/programacion-api.service';
import { MaterialModule } from '../material/material.module';
import { PrimengModule } from '../primeng/primeng.module';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { PipelineEstadoNovedadComponent } from './components/pipeline-estado-novedad/pipeline-estado-novedad.component';
import { SectionHeaderComponent } from './components/section-header/section-header.component';
import { SelectCheckAll } from './components/selectAll/select-check-all.component';
import { FechaPipe } from './pipes/fecha.pipe';
import { HoraPipe } from './pipes/hora.pipe';
import { ListaDiasPipe } from './pipes/lista-dias.pipe';
import { ListaFrecuenciaPipe } from './pipes/lista-frecuencias.pipe';
import { ProfesionalPipe } from './pipes/profesional.pipe';
import { ProveedorEstadoPipe } from './pipes/proveedor-estado.pipe';
import { ReplaceUnderscorePipe } from './pipes/replaceUnderscore.pipe';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { SepararLetraPipe } from './pipes/separar-letra.pipe';
import { SepararPorMayusculaPipe } from './pipes/separarPorMayuscula.pipe';
import { TextoBooleanoPipe } from './pipes/texto-booleano.pipe';
import { TipoCambioCitaPipe } from './pipes/tipo-cambio-cita.pipe';
import { TipoSondajePipe } from './pipes/tipo-sondaje.pipe';
import { TruncarCadenaPipe } from './pipes/truncar-cadena.pipe';
import { FormService } from './services/form.service';
import { UsuarioService } from './services/usuario.service';


@NgModule({
  imports: [
    CommonModule,
    PrimengModule,
    MaterialModule,
    RouterModule,
    PipelineEstadoNovedadComponent,
  ],
  declarations: [
    FechaPipe,
    TextoBooleanoPipe,
    TruncarCadenaPipe,
    ListaFrecuenciaPipe,
    TipoSondajePipe,
    HoraPipe,
    SepararLetraPipe,
    SepararPorMayusculaPipe,
    ProveedorEstadoPipe,
    ListaDiasPipe,
    MenuComponent,
    MenuItemComponent,
    InicioComponent,
    AssetspipePipe,
    ProfesionalPipe,
    ModalConfirmacionComponent,
    SectionHeaderComponent,
    TipoCambioCitaPipe,
    SelectCheckAll,
    SafeUrlPipe,
    ReplaceUnderscorePipe
  ],
  providers: [
    ComunService,
    UsuarioService,
    ProgramacionService,
    FormService,
  ],
  exports: [
    FechaPipe,
    TextoBooleanoPipe,
    TruncarCadenaPipe,
    ListaFrecuenciaPipe,
    TipoSondajePipe,
    HoraPipe,
    ProfesionalPipe,
    SepararLetraPipe,
    SepararPorMayusculaPipe,
    ProveedorEstadoPipe,
    ListaDiasPipe,
    ModalConfirmacionComponent,
    SectionHeaderComponent,
    MenuComponent,
    MenuItemComponent,
    InicioComponent,
    TipoCambioCitaPipe,
    SelectCheckAll,
    SafeUrlPipe,
    MaterialModule,
    PrimengModule,
    ReplaceUnderscorePipe,
    PipelineEstadoNovedadComponent,
  ],
})
export class SharedModule {
}
